module.exports = __webpack_public_path__ + "static/family-248ce7209690c1d298627f4edc771a7a.jpg";